export function getLS<T extends string>(key: T) {
  return localStorage.getItem(key)
}

export function setLS(key: string, value: string) {
  localStorage.setItem(key, value);
}

export function removeLS(key: string) {
  localStorage.removeItem(key);
}